import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classnames from 'classnames';
import styles from "./PlanCard.module.scss";
import { CheckList } from "../../List/CheckList/CheckList";
import { InfoButton } from "../../Button/InfoButton/InfoButton";
import { CollapsibleUpwardsPanel } from "../../CollapsibleUpwardsPanel/CollapsibleUpwardsPanel";
import { useState } from 'react';
import { PricingForm } from "../PricingForm/PricingForm";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PlanCard = function PlanCard(_ref) {
  var _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? '' : _ref$headerText,
    _ref$subHeaderText = _ref.subHeaderText,
    subHeaderText = _ref$subHeaderText === void 0 ? '' : _ref$subHeaderText,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$mainButton = _ref.mainButton,
    mainButton = _ref$mainButton === void 0 ? {} : _ref$mainButton,
    _ref$asteriskText = _ref.asteriskText,
    asteriskText = _ref$asteriskText === void 0 ? '' : _ref$asteriskText,
    _ref$hasMoreOptions = _ref.hasMoreOptions,
    hasMoreOptions = _ref$hasMoreOptions === void 0 ? false : _ref$hasMoreOptions,
    _ref$moreOptions = _ref.moreOptions,
    moreOptions = _ref$moreOptions === void 0 ? [] : _ref$moreOptions,
    _ref$moreOptionsText = _ref.moreOptionsText,
    moreOptionsText = _ref$moreOptionsText === void 0 ? '' : _ref$moreOptionsText,
    _ref$lessOptionsText = _ref.lessOptionsText,
    lessOptionsText = _ref$lessOptionsText === void 0 ? '' : _ref$lessOptionsText,
    _ref$checkListMinHeig = _ref.checkListMinHeight,
    checkListMinHeight = _ref$checkListMinHeig === void 0 ? '' : _ref$checkListMinHeig,
    _ref$cardMinHeight = _ref.cardMinHeight,
    cardMinHeight = _ref$cardMinHeight === void 0 ? '' : _ref$cardMinHeight,
    _ref$currentZipCode = _ref.currentZipCode,
    currentZipCode = _ref$currentZipCode === void 0 ? '' : _ref$currentZipCode,
    _ref$onZipCodeChange = _ref.onZipCodeChange,
    onZipCodeChange = _ref$onZipCodeChange === void 0 ? function () {} : _ref$onZipCodeChange,
    _ref$hasRecomendedTag = _ref.hasRecomendedTag,
    hasRecomendedTag = _ref$hasRecomendedTag === void 0 ? false : _ref$hasRecomendedTag;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isZipModalOpen = _useState2[0],
    setIsZipModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMoreOptionsOpen = _useState4[0],
    setIsMoreOptionsOpen = _useState4[1];
  var hasZipCode = !!currentZipCode;
  var buildInfoButton = function buildInfoButton(info, key, className) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'primary';
    var tabIndexProp = isMoreOptionsOpen || type === 'primary' ? {} : {
      tabIndex: -1
    };
    var mergedAttributes = _objectSpread(_objectSpread({}, info === null || info === void 0 ? void 0 : info.attributes), tabIndexProp);
    var mergedInfoAttributes = _objectSpread(_objectSpread({}, info === null || info === void 0 ? void 0 : info.infoAttributes), tabIndexProp);
    return /*#__PURE__*/_jsx(InfoButton, _objectSpread(_objectSpread({
      buttonClassName: className,
      bestValueText: info === null || info === void 0 ? void 0 : info.tag,
      url: info === null || info === void 0 ? void 0 : info.link,
      buttonText: info === null || info === void 0 ? void 0 : info.text,
      buttonType: type,
      popupText: info === null || info === void 0 ? void 0 : info.offerTerms,
      accessibilityLabel: (info === null || info === void 0 ? void 0 : info.termsAccessibilityLabel) || 'View offer terms and conditions'
    }, mergedAttributes), {}, {
      infoAttributes: mergedInfoAttributes
    }), key);
  };
  var moreOptionsAggregated = {
    buttonText: moreOptionsText || 'More Options',
    buttonTextOpen: lessOptionsText || 'Less Options',
    wrapperClassName: styles.collapsibleWrapper,
    onClick: function onClick(isOpen) {
      return setIsMoreOptionsOpen(isOpen);
    },
    children: moreOptions && /*#__PURE__*/_jsx("div", {
      className: styles.secondaryButton,
      children: moreOptions.map(function (option, index) {
        return buildInfoButton(option, "moreoptions_".concat(index), styles.secondaryText, 'secondary');
      })
    })
  };
  var pricing = {
    zipText: '',
    zipOrLocation: currentZipCode,
    input: {
      arrowButton: false,
      buttonText: 'Update',
      onSubmit: function onSubmit(value) {
        if (value) {
          if (onZipCodeChange) {
            onZipCodeChange(value);
          }
        }
        setIsZipModalOpen(false);
      },
      placeholder: 'Zip Code',
      regex: new RegExp('^\\d{5}([ \\-]\\d{4})?$'),
      regexErrorMessage: 'Please enter a valid zipcode'
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.planCard,
    style: {
      top: !hasRecomendedTag ? '8px' : '0'
    },
    children: [hasRecomendedTag && /*#__PURE__*/_jsx("div", {
      className: styles.recomended,
      children: /*#__PURE__*/_jsx("span", {
        className: styles.recomendedTag,
        children: "Recommended"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.card),
      style: {
        minHeight: cardMinHeight
      },
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.header,
        children: headerText
      }), /*#__PURE__*/_jsx("span", {
        className: styles.subHeader,
        children: subHeaderText
      }), /*#__PURE__*/_jsx(CheckList, {
        items: items,
        checkListClassName: styles.checkList,
        minHeight: checkListMinHeight
      }), /*#__PURE__*/_jsx("div", {
        className: styles.divButton,
        children: buildInfoButton(mainButton, 'btnBestValue', styles.bestValueButton, 'primary')
      }), hasMoreOptions && /*#__PURE__*/_jsx("div", {
        className: styles.moreOptions,
        children: /*#__PURE__*/_jsx(CollapsibleUpwardsPanel, _objectSpread({}, moreOptionsAggregated))
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.asterisk,
        children: [/*#__PURE__*/_jsx("span", {
          children: asteriskText
        }), hasZipCode && /*#__PURE__*/_jsxs("span", {
          children: [' ', "Prices based on your zip code:", ' ', /*#__PURE__*/_jsx("span", {
            className: styles.zipCode,
            onClick: function onClick() {
              return setIsZipModalOpen(true);
            },
            children: currentZipCode
          })]
        })]
      }), hasZipCode && isZipModalOpen && /*#__PURE__*/_jsx("div", {
        className: styles.modalOverlay,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.zipModal,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.pricingFormWrapper,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.zipModalHeader,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.zipModalHeaderText,
                children: "Update your zip code"
              }), /*#__PURE__*/_jsx("span", {
                className: styles.closeButton,
                onClick: function onClick() {
                  return setIsZipModalOpen(false);
                },
                children: "X"
              })]
            }), /*#__PURE__*/_jsx(PricingForm, {
              isOpen: true,
              pricing: pricing
            })]
          })
        })
      })]
    })]
  });
};